import { useCallback } from 'react';
import { useLookerDashboardContext } from '../../providers/LookerDashboardProvider';
import { useFiltersStore } from '../../stores/filters';
import { useFilterUIStore } from '../../stores/filterUI';
import { useCurrentWorkspace } from '../useCurrentWorkspace';

export function useFilters() {
  const { currentWorkspace } = useCurrentWorkspace();
  const { filters, ...filterStore } = useFiltersStore();
  const { openFilterName, isFilterSelectorVisible, closeOverlay, setFilterSelectorVisible, ...filterUIStore } =
    useFilterUIStore();
  const { updateDashboard } = useLookerDashboardContext();

  const advertiserId = filters?.advertiser_filter?.advertiserId ?? currentWorkspace?.workspace_advertiser_id;

  const closeFilterDrawer = useCallback(() => {
    setFilterSelectorVisible(false);
    closeOverlay();
    updateDashboard();
  }, [closeOverlay, setFilterSelectorVisible, updateDashboard]);

  return {
    advertiserId,
    filters,
    openFilterName,
    isFilterSelectorVisible,
    closeOverlay,
    setFilterSelectorVisible,
    closeFilterDrawer,
    ...filterUIStore,
    ...filterStore,
  };
}
